import { Accordion } from '@definitions/types/storyblokTypes'

import { StoryblokAccordion } from './StoryblokAccordion'

export default StoryblokAccordion

export const dummyAccordionBlok: Accordion = {
  _uid: '036a95a2-4a72-4525-b61d-133162ce8f69',
  items: [
    {
      _uid: 'ffc5ecf7-2ea8-4f9e-9876-5e14ae6f833e',
      content: {
        type: 'doc',
        content: [
          {
            type: 'paragraph',
            content: [
              {
                text: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
                type: 'text',
              },
            ],
          },
        ],
      },
      headline: 'Lorem ipsum dolor sit amet',
      component: 'accordion-item',
      _editable:
        '<!--#storyblok#{"name": "accordion-item", "space": "235453", "uid": "ffc5ecf7-2ea8-4f9e-9876-5e14ae6f833e", "id": "367795855"}-->',
    },
    {
      _uid: '7a93ee3d-7bdb-4818-9e82-5197f4a972ce',
      content: {
        type: 'doc',
        content: [
          {
            type: 'paragraph',
            content: [
              {
                text: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
                type: 'text',
              },
            ],
          },
        ],
      },
      headline: 'Lorem ipsum dolor sit amet, ',
      component: 'accordion-item',
      _editable:
        '<!--#storyblok#{"name": "accordion-item", "space": "235453", "uid": "7a93ee3d-7bdb-4818-9e82-5197f4a972ce", "id": "367795855"}-->',
    },
    {
      _uid: '65401038-b33e-42b9-8282-205dde0d080e',
      content: {
        type: 'doc',
        content: [
          {
            type: 'paragraph',
            content: [
              {
                text: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
                type: 'text',
              },
            ],
          },
        ],
      },
      headline: 'Lorem ipsum dolor sit amet,',
      component: 'accordion-item',
      _editable:
        '<!--#storyblok#{"name": "accordion-item", "space": "235453", "uid": "65401038-b33e-42b9-8282-205dde0d080e", "id": "367795855"}-->',
    },
  ],
  headline: 'SUNRL-113 Akkordeon',
  component: 'accordion',
  _editable:
    '<!--#storyblok#{"name": "accordion", "space": "235453", "uid": "036a95a2-4a72-4525-b61d-133162ce8f69", "id": "367795855"}-->',
}
